<script setup lang="ts">
import { ref } from 'vue';
import { DgrIcon } from '@stockmarkteam/donguri-ui';
import SearchSuggestionsInput from '@/components/search/search-suggestions-input.vue';
import {
  SEARCH_MAX_LENGTH,
  useKeywordSearchQuery,
} from '@/utils/composables/useKeywordSearchQuery';

const { query, search } = useKeywordSearchQuery();

const inputRef = ref<HTMLInputElement>();

const deleteHistory = () => inputRef.value?.focus();
</script>

<template>
  <div class="m-keyword-search-bar">
    <SearchSuggestionsInput
      v-model="query"
      @search="search"
      @delete-history="deleteHistory"
    >
      <template #default="{ value, handlers }">
        <input
          ref="inputRef"
          class="c-textInput"
          :class="{ 'too-long': query.length >= SEARCH_MAX_LENGTH }"
          type="text"
          placeholder="検索ワードを入力してください"
          :value="value"
          v-on="handlers"
          :maxlength="SEARCH_MAX_LENGTH"
          v-tooltip.bottom="
            query.length >= SEARCH_MAX_LENGTH
              ? '200文字以内で入力してください'
              : undefined
          "
        />
      </template>
    </SearchSuggestionsInput>
    <button
      class="m-search-button"
      :disabled="query.trim() === ''"
      @click="search"
    >
      <DgrIcon name="search" :keep-fill="false" />
    </button>
  </div>
</template>
<style lang="scss" scoped>
.m-keyword-search-bar {
  display: flex;
  margin-left: 130px;
  .c-textInput {
    padding-right: 54px;
    width: 520px;
    outline: none;

    &.too-long {
      border-color: $color-orange1000;
    }
  }
  .m-search-button {
    margin: 4px 5px 0 -50px;
    padding: 4px 11px;
    height: 32px;
    border: 0;
    background: #fff;
    &:hover:not(:disabled) {
      background: $color-gray200;
    }
    .icon-box {
      padding: 0;
      color: $color-gray600;
    }
  }
}
</style>
